module.exports = __webpack_public_path__ + "images/800x800_Individual_0000s_0004_Suso_mango-and-passion_2.png";